export default __webpack_public_path__ + "static/media/background.eeff5e53.jpg";